@if (entreprise) {
  <div class="personne-infos" (mouseleave)="fermer()" (mouseenter)="hideCancelled=true">
    @if (logoData != null) {
      <div class="photo-part"  (click)="navigateToFicheEntreprise()">
        <img [src]="logoData" alt="photo">
      </div>
    }
    <div class="infos-part" (click)="navigateToFicheEntreprise()">
      <div class="nomprenom">{{entreprise.raisonSociale}}</div>
      @if (hasVille) {
        <div class="tel">{{entreprise.ville}}</div>
      }
    </div>
  </div>
}

